import { ContactSequence, Tooltip } from "@components"
import { ShieldCheckIcon } from "@heroicons/react/24/outline"
import { ShieldCheckIcon as ShieldIconSolid } from "@heroicons/react/24/solid"
import PropTypes from "prop-types"

const GuardianStudentDetails = ({ contactSequence, legalGuardian }) => (
  <div className="flex items-center space-x-2">
    <Tooltip content="Contact Sequence">
      <ContactSequence size="sm" priority={contactSequence} />
    </Tooltip>

    {legalGuardian && (
      <Tooltip content="Legal Guardian">
        <ShieldIconSolid className="w-8 h-8 text-center text-green-400" />
      </Tooltip>
    )}

    {!legalGuardian && (
      <Tooltip content="Legal Guardian">
        <ShieldCheckIcon className="w-8 h-8 text-center text-gray-400" />
      </Tooltip>
    )}
  </div>
)


GuardianStudentDetails.propTypes = {
  contactSequence: PropTypes.number.isRequired,
  legalGuardian: PropTypes.bool.isRequired,
}

export default GuardianStudentDetails